import { SvgIcon, SvgIconProps } from '@mui/material';

const Visibility = ({ viewBox = '0 0 24 24', sx, ...props }: SvgIconProps) => (
  <SvgIcon
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 24, fill: 'none', ...sx }}
    data-testid="visibilityIcon"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5C7 5 2.25 12 2.25 12C2.25 12 7 19 12 19C17 19 21.75 12 21.75 12C21.75 12 17 5 12 5ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill="#373B49"
    />
  </SvgIcon>
);

export default Visibility;
